module.exports = __webpack_public_path__ + "img/expostyle_0939_violet.18576af6.jpg";